var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('search-and-pick',{attrs:{"items":_vm.clientPickerItems,"value":_vm.value,"label":_vm.label,"multiple":false},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }